import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Megaphone, Save } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Card } from "@/components/ranger/PageHeader";
import { BTN_PRIMARY } from "@/pages/Servers";
import { api, errMsg } from "@/lib/api";

export const LinkAnnounce = ({ cid, canEdit }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get(`/communities/${cid}/moderation-config`).then((r) => setCfg(r.data)).catch(() => {}); }, [cid]);
  if (!cfg) return null;
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put(`/communities/${cid}/moderation-config`, { link_announce: cfg.link_announce, link_message: cfg.link_message }); setCfg(data); toast.success("Link announcement saved"); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Card title="Link announcement" icon={Megaphone} testId="link-announce-card">
      <form onSubmit={save} className="space-y-4">
        <label className="flex items-center gap-3 text-sm text-slate-300"><Switch data-testid="link-announce-switch" disabled={!canEdit} checked={cfg.link_announce} onCheckedChange={(v) => setCfg({ ...cfg, link_announce: v })} />Announce in-game when a player links</label>
        <Input data-testid="link-announce-message-input" disabled={!canEdit} maxLength={160} value={cfg.link_message} onChange={(e) => setCfg({ ...cfg, link_message: e.target.value })} className="border-[#1E2D4A] bg-[#050811]" aria-label="Announcement message" />
        <p className="text-xs text-slate-500">{"{gamertag}"} is replaced with the player's name. Sent once, on their first successful link, via RCON say. No quotes or semicolons.</p>
        {canEdit && <button data-testid="link-announce-save-button" className={BTN_PRIMARY}><Save className="h-4 w-4" />Save</button>}
      </form>
    </Card>
  );
};
